import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../../app.config';
import { WorkQueueModel } from '../work-queue/work-queue.model';
import { AccountViewModel, QueueActionsModel } from './account-view.model';

@Injectable({
  providedIn: 'root',
})
export class AccountViewService {
  constructor(private httpClient: HttpClient, private toastrService: ToastrService) { }

  getWorkQueueDetails(id: number): Observable<WorkQueueModel> {
    return this.httpClient.get<WorkQueueModel>(`${AppConfig.settings.settings.apiEndpoint}api/WorkQueue/GetWorkQueueDetail?id=${id}`)
      .pipe(map(value => {
        return value;
      }));
  }

  getNextWorkQueue(queueType: number, workqueueStatusId: number, id: number,
    accountUpdateOptionId: number, customerFollowUpOptionId: number, investigationOptionId: number, insuranceFollowUpOptionId: number): Observable<number> {
    return this.httpClient.get<number>(`${AppConfig.settings.settings.apiEndpoint}api/WorkQueue/GetNextQueue?queueType=${queueType}&workqueueStatusId=${workqueueStatusId}&queueid=${id}&accountUpdateOptionId=${accountUpdateOptionId === -1 ? '' : accountUpdateOptionId}&customerFollowUpOptionId=${customerFollowUpOptionId === -1 ? '' : customerFollowUpOptionId}&investigationOptionId=${investigationOptionId === -1 ? '' : investigationOptionId}&insuranceFollowUpOptionId=${insuranceFollowUpOptionId === -1 ? '' : insuranceFollowUpOptionId }`)   
      .pipe(map(value => {
        return value;
      }));
  }

  postQueueActions(queueActions: any[]): Observable<boolean> {
    return this.httpClient.post<boolean>(`${AppConfig.settings.settings.apiEndpoint}api/AccountView/PostQueueActions`, queueActions)
      .pipe(map(value => {
        if (value == null || value === false) {
          this.toastrService.error('Queue Update Failed', 'Error');
        } else {
          this.toastrService.success('Queue Updated Successfully', 'Success');
        }
        return value;
      }));
  }
}
